import { createGenericSlice } from '../../../../../utils/slices'

export const leftHipSlice = createGenericSlice({
  name: 'leftHip',
  initialState: {
    type: 'truss',
    material: 5,
    width: 1.5,
    depth: 5.5,
    ply: 1,
    memberID: 'L.Hip 1',
    // skewType: 1,
    skewAngle: 45,
    // slopeType: 0,
    slopeAngle: 0,
    load: 0,
    uplift: 0,
  },
})

export const leftHipActions = leftHipSlice.actions
